import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Loader from 'react-loader';
import Auth from '../services/auth';
const auth = new Auth();

class Callback extends Component {
  componentDidMount() {
    const { location } = this.props;
    if (/access_token|id_token|error/.test(location.hash)) {
      auth.handleAuthentication(() => {
        this.props.history.push('/');
      });
    }
  }

  render() {
    return <Loader loaded={false} />;
  }
}

export default withRouter(Callback);



// WEBPACK FOOTER //
// ./src/pages/Callback.js